import React from "react";
import { Td, Tr } from "@chakra-ui/react";
import { useHistory } from "react-router-dom";


const TableRow = ({ type, street, alert }) => {
  const history = useHistory();

  return (
    <Tr bg="#FFF">
      <Td>{alert || "Name"}</Td>
      <Td borderLeft={"1px solid grey"}>{street || "Street"}</Td>
      <Td borderLeft={"1px solid grey"}>{type || "Emergency"}</Td>
      <Td
        borderLeft={"1px solid grey"}
        color="#072f64"
        cursor={"pointer"}
        onClick={() => history.push("/manager/emergency")}
      >
        {"View"}
      </Td>
    </Tr>
  );
};

export default TableRow;
